import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { BaseCard } from '../BaseCard/BaseCard';
import { PeopleDetailSection } from '../PeopleDetailSection/PeopleDetailSection';
import { noCardBoxShadow } from '../../Styles';

export interface IPeopleDetailHighlightsProps {
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const StyledBaseCard = styled(BaseCard)`
  display: flex;
  margin-bottom: 5px;
  font-weight: 500;
  position: relative;
  left: -10px;
  padding: 10px;
  ${noCardBoxShadow}
`;

export const PeopleDetailHighlights: FunctionComponent<IPeopleDetailHighlightsProps> = props => {
  const { children, onClick } = props;
  return (
    <PeopleDetailSection title="Highlights">
      <StyledBaseCard onCardClick={onClick} screenReaderText="External link to LinkedIn">
        {children}
      </StyledBaseCard>
    </PeopleDetailSection>
  );
};

export default PeopleDetailHighlights;
